"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('bson'),
  ObjectId = _require.ObjectId;
var tv4 = require('tv4');
var _require2 = require('lodash'),
  isEqual = _require2.isEqual;
var CATALOG_TYPE = require('../../constant/library/catalog-type.constant');
var BioDetails = require('./details/bio-details');
var PPEDetails = require('./details/ppe-details');
var LibraryItem = /*#__PURE__*/function () {
  function LibraryItem(opt) {
    _classCallCheck(this, LibraryItem);
    this._id = null;
    this.catalog = null;
    this.name = null;
    this.description = null;
    this.tags = null;
    this.details = null;
    if (opt) {
      this.fillObject(_objectSpread({}, opt));
    }
  }
  _createClass(LibraryItem, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.catalog = opt.catalog || null;
      this.name = opt.name || null;
      this.description = opt.description || null;
      this.tags = opt.tags || [];
      switch (opt.catalog) {
        case CATALOG_TYPE.BIOLOGICAL:
          this.details = new BioDetails(opt.details);
          break;
        case CATALOG_TYPE.EQUIPMENT:
          this.details = null;
          break;
        case CATALOG_TYPE.PPE:
          this.details = new PPEDetails(opt.details);
          break;
        case CATALOG_TYPE.SERVICES:
          this.details = null;
          break;
        default:
          this.details = null;
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      var validation = tv4.validateMultiple(this, LibraryItem.schema());
      var isDetailsValid = this.validateDetails(this.catalog, this.details);
      if (!isDetailsValid) {
        validation.errors.push(new Error("Invalid details for catalog ".concat(this.catalog)));
        validation.valid = false;
      }
      return validation;
    }
  }, {
    key: "validateDetails",
    value: function validateDetails() {
      var catalog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.catalog;
      var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.details;
      switch (catalog) {
        case CATALOG_TYPE.PPE:
          return new PPEDetails(details).validate().valid;
        case CATALOG_TYPE.BIOLOGICAL:
          return isEqual(Object.keys(details).sort(), Object.keys(new BioDetails()).sort());
        default:
          return false;
      }
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'library-item.schema.json',
        title: 'library Item Schema',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'object'
          },
          catalog: {
            "enum": Object.keys(CATALOG_TYPE)
          },
          name: {
            type: 'string'
          },
          description: {
            type: ['string', 'null']
          },
          tags: {
            type: 'array',
            minItems: 1
          },
          details: {
            oneOf: [{
              $ref: 'library-item.bio.details.schema.json'
            }, {
              $ref: 'library-item.ppe.details.schema.json'
            }, {
              type: 'null'
            }]
          }
        },
        required: Object.keys(new LibraryItem())
      };
    }
  }]);
  return LibraryItem;
}();
tv4.addSchema(BioDetails.schema());
tv4.addSchema(PPEDetails.schema());
module.exports = LibraryItem;